import { AxiosResponse } from 'axios'
import { API } from '../config'
import { FileDto } from 'src/dto/file.dto'

export class FileService {
  private readonly BASE_URL = '/arquivo'
  public async uploadFile(
    farmId: string,
    entity: string,
    referenceId: string,
    file: File
  ): Promise<AxiosResponse<FileDto>> {
    const formData = new FormData()
    formData.append('file', file)

    return await API.post(`${this.BASE_URL}/${farmId}/${entity}/${referenceId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  public async listFiles(farmId: string, entity: string, referenceId: string): Promise<AxiosResponse<FileDto[]>> {
    return await API.get(`${this.BASE_URL}/${farmId}/${entity}/${referenceId}`, {
      params: { comConteudo: false }
    })
  }

  public async getFile(
    farmId: string,
    entity: string,
    referenceId: string,
    fileId: string
  ): Promise<AxiosResponse<Blob>> {
    return await API.get(`${this.BASE_URL}/${farmId}/${entity}/${referenceId}/${fileId}/file`, {
      responseType: 'blob'
    })
  }

  public async deleteFile(
    farmId: string,
    entity: string,
    referenceId: string,
    file?: FileDto
  ): Promise<AxiosResponse<FileDto>> {
    return await API.delete(`${this.BASE_URL}/${farmId}/${entity}/${referenceId}/${file?.idArquivo}`)
  }
}
